import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-ro",
  "use": "icon-icon-ro-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-ro\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\">\n    <path fill=\"#00319c\" d=\"M0 0h170.7v512H0z\" />\n    <path fill=\"#ffde00\" d=\"M170.7 0h170.6v512H170.7z\" />\n    <path fill=\"#de2110\" d=\"M341.3 0H512v512H341.3z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol